<template>
  <div class="mypage-myinfo-page-container">
    <h1>마이페이지</h1>
    <MyPageNavigatorVue />
    <MyPageMyInfoVue />
  </div>
</template>

<script>
import MyPageNavigatorVue from '@/components/MyPage/MyPageNavigator.vue'
import MyPageMyInfoVue from '@/components/MyPage/MyPageMyInfo/MyPageMyInfo.vue'

export default {
  name: 'MyPageMyInfo',
  components: {
    MyPageMyInfoVue,
    MyPageNavigatorVue,
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style>
.mypage-myinfo-page-container {
  display: flex;
  flex-direction: column;
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  box-sizing: border-box;
  font-family: var(--font-sans);
}
</style>